let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

var id = getUrlParameter('id'), f_name = "", C_number = "", C_email = "", user__gender = "", user_gender = "", rid = "", caseId = "", selectedStage = 'Stage-1';
var cohort = getUrlParameter('cohort'), variantsID = 0, recommended_products = [], variantsIDs = [];
var prices = 0, doc__fee = 100000, diet__plan = 50000, hair__coach_fee = 50000, month1_total, month1DiscountPrice, month3DiscountPrice, month6DiscountPrice, discount_pricetext = 0;
let successfulFetchCount = 0, totalProducts = 0;
if (id) {
  localStorage.setItem('user-gender', 'male');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id === undefined) {
  id = getCookie('syntheticId');
}
(function () {
  if(!id) {
    if(window.location.pathname == '/pages/result4a'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://form.traya.health/questions?cohort=1&source=ResultPage'
    }
  var data_formPage = document.querySelectorAll('[data-formPage]'),
      data_resultPage = document.querySelectorAll('[data-resultPage]'),
      data_resultbtn = document.querySelectorAll('[data-resultbtn]'),
      data_notResult = document.querySelectorAll('[data-notResult]');
    if(data_formPage.length != 0) {
      data_formPage.forEach((formpage) => { formpage.style.display = "block"; });
    }
    if(data_resultPage.length != 0) {
      data_resultPage.forEach((resultpage) => { resultpage.style.display = "none"; });
    }
    if(data_resultbtn.length != 0) {
      data_resultbtn.forEach((resultbtn) => { resultbtn.style.display = "none"; });
    }
    if(data_notResult.length != 0) {
      data_notResult.forEach((notresult) => { notresult.style.display = "block"; });
    }
  }else {
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var data_result = document.querySelectorAll('[data-result]');
    if(data_result.length != 0) {
      data_result.forEach((result) => { result.style.display = "block"; })
    }
  }
  var baseUrls = {
    // DEV: 'https://api.v2dev.hav-g.in/',
    DEV: 'https://revamp-api.dev.hav-g.in/',
    PROD: 'https://api.hav-g.in/'
  };
  var tokens = {
    DEV: { 
      "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: { 
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };
  var token = tokens.PROD;
  var baseUrl = baseUrls.PROD;
  var liveendpoint = 'https://api.hav-g.in/dgReport?id=';
  if (cohort == 2) {
    liveendpoint = baseUrl + 'dgReport/male?id=';
  } else {
    liveendpoint = baseUrl + 'dgReport/male?id=';
  }
  liveendpoint = 'https://api.hav-g.in/dgReport/male?id=';
  window.addEventListener('DOMContentLoaded', function() {
    clearCart();
    var atcButton = document.querySelectorAll('#add-to-cart-result-page');
    if (atcButton.length !== 0) {
      atcButton.forEach((button) => {
        button.addEventListener('click', function () {
          button.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
          button.classList.add('loader-added')
          button.disabled = true;
          const addToCartEvent = 'result_add_to_cart';
          const addToCartEventData = { "gender": "Male" };
          Shopify.analytics.publish(addToCartEvent, addToCartEventData);
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 100); 
          setTimeout(() => {
            button.disabled = false;
            button.classList.remove('loader-added');
            button.style.textTransform = 'capitalize';
            button.innerHTML = `<span class="Rmoney_buy mr-1 mr-md-5">Buy Now</span>`;
            button.style.color = '#000';
          }, 1500);
        });
      });
    }
    getMaleResult(liveendpoint, id, token);
  })
})();

async function clearCart() {
  var formdata = {
    sections: 'cart-drawer'
  };
  await fetch('/cart/clear.js', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formdata)
  }).then((response) => {
    return response.json();
  }).then((result) => {
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer, drawer=false,0);
  }).catch((error) => {
    console.error('Error: ', error);
  })
}

// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

async function getMaleResult(livepoint, id, token) {
  document.body.style.overflow = 'hidden';
  try {
    const response = await fetch(`${livepoint}${id}`, {
      headers: token
    });
    const data = await response.json();
    
   const caseId = String(data?.User_Analysis?.case_id).trim();
   tagClarityCaseId(caseId);
   const kitSectionButtonLink = document.querySelectorAll('button.kit-section-btn.section-button-link');
   kitSectionButtonLink.forEach((button) => {
     button.addEventListener('click', ()=>{
       fireEvent("detailed_result_page", caseId);
       window.location.href = `/pages/result-details?id=${id}`;
     });
   })
    fireEvent("rp_landed", caseId); 
    ShowContent(data);
    rootCause(data?.root_causes);
    resultMonthKit(data);
    getProductByHandle(data);
    displayProduct(data);
    displayStageSection(data);
    sectionMonthsExpectetion(data);
    trackMetaEvent(data.User_Analysis, "Viewed Content");
    addClickEventListernerToMonthkit();
  } catch (error) {
    console.error('Error: ', error);
    document.body.style.overflow = 'unset';
  } finally {
    await clearCart(); 
    checkout();
  }
}

function fireEvent(eventName, caseID) {
  let pageURL = window.location.href;
  const attributes = {
    platform: "web_shopify",
    domain: "traya.health",
    pageUrl: pageURL,
    syntheticId: window.location.search.substring(1).split('=')[1] || "default-id"
  };

  const baseAPI = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  const baseTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  fetch(`${baseAPI.PROD}eventMoengageWeb`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...baseTokens.PROD
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        generalAttributes: attributes
      },
      "caseId": caseID
    })
  });
}

// const kitSectionButtonLinkEvent = document.querySelectorAll('button.kit-section-btn a.section-button-link');
// kitSectionButtonLinkEvent.forEach((eventButton) => {

// })

// Checking Eligibility
function checkEligibility() {
  // Hide the checking container and show the loading container
  document.querySelector('.checking-container').style.display = 'none';
  document.querySelector('.loading-container').style.display = 'flex';
  
  // Simulate an API call with setTimeout
  setTimeout(() => {
    // Hide the loading container and show the eligibility result container
    document.querySelector('.loading-container').style.display = 'none';
    document.querySelector('.eligibilty-result').style.display = 'block';
  }, 1000); // Change the duration as needed
}
        
// doctor assigned section
function sectionCoach(response) {
  let stagesDoctorAssigned = response.currentStage;
  let assignedDoctor = document.querySelector('.doctor-assigned');
  let assignedDoctorPending = document.querySelector('.doctor-assigned--pending');
  const responseStage = stagesDoctorAssigned.stage; 
  
  if(assignedDoctor || assignedDoctorPending){
    if (responseStage === 'Stage-1') {
      assignedDoctor.style.display = 'block';
      assignedDoctorPending.style.display = 'none';
    } else {
      assignedDoctor.style.display = 'none';
      assignedDoctorPending.style.display = 'block'; 
    }
  }
}

// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

function showProductDetails(productId, language) {
  if (!productId) {
    console.error('Product ID is undefined');
    return;
  }
  const tokens = {
    DEV: { 
      "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: { 
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };

  const nativeLink = {
    devLink: { 
      "siteLink": "public-zxhj2.dev.hav-g.in"
    },
    prodLink: { 
      "siteLink": "public-jgfas325.hav-g.in"
    }
  };

  fetch(`https://${nativeLink.devLink.siteLink}/productContentv2/${productId}?language=${language}`, {
      headers: tokens.DEV // Using the DEV token as before
  })
  .then((response) => {
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .then((data) => {
      createProductPopup(productId);
  })
  .catch((error) => {
      console.error('Error fetching data:', error);
  });
}

// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "form.traya.health"
    }
  };

  const iframeUrl = `https://${siteUrl.dev.Link}/product-drawerv2/${productId}`;
  
  // Load external product detail page into popup content placeholder
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    // Mobile view: popup from the bottom
    popup.style.bottom = '0';
  } else {
    // Desktop view: popup from the right
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Close popup when close icon is clicked
  const closeIcon = document.querySelector('#product-popup #close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });

  // Close popup when overlay is clicked
  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

// Function to add click event listener to month kit product cards
function addClickEventListernerToMonthkit() {
  document.querySelectorAll('.shopify-kit-section .kit-card-container').forEach((kit) => {
    kit.addEventListener('click', function (event) {
      const productId = event.currentTarget.getAttribute('data-product-id');
      const language = 'english'; 
      showProductDetails(productId, language);
    });
  });
}

// Function to create the month kit section
function resultMonthKit(response) {
  const productData = response.product_Ids;
  const priceCart = response.cart_price
  
  const containerDiv = document.querySelector('.result-product-kit-wrapper');

  const header = document.createElement('h2');
  header.classList.add('kit-header', 'section-heading-font');
  header.innerText = 'Start your journey with just 1 month kit';
  containerDiv.appendChild(header);

  if(window.innerWidth <= 767){
    containerDiv.classList.remove('container');
  }

  const newSection = document.createElement('section');
  newSection.classList.add('shopify-kit-section');

  // new json data for the title and descritpion
  const updatedDataFromAPI = [
    {
      "variantId": "46528923304114",
      "name": "For Advanced Dandruff",
      "one_liner": "Advanced Anti-Dandruff Solution for stubbon dandruff"
    },
    {
      "variantId": "47329496826034",
      "name": "For Dandruff",
      "one_liner": "Anti-Dandruff Shampoo with proven actives"
    },
    {
      "variantId": "41645770309810",
      "name": "For Hair Regrowth",
      "one_liner": "Recap Serum with Hair Growth Actives"
    },
    {
      "variantId": "47329517568178",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 2% that prevents hormone led hair damage"
    },
    {
      "variantId": "47302891929778",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 5% that prevents hormone led hair damage"
    },
    {
      "variantId": "47301151064242",
      "name": "For Hair Hygiene",
      "one_liner": "Defence Shampoo for pH balance (SLS Free)"
    },
    {
      "variantId": "44650256728242",
      "name": "For Hair Texture",
      "one_liner": "Defence Conditioner for hydrated hair (SLS Free)"
    },
    {
      "variantId": "47276533121202",
      "name": "For Sleep",
      "one_liner": "Nasal Ghrit for restful sleep"
    },
    {
      "variantId": "46528902496434",
      "name": "For Digestion",
      "one_liner": "Gut Shuddi for constipation relief"
    },
    {
      "variantId": "46528906821810",
      "name": "For Hair Nutrition",
      "one_liner": "Hair Ras for hair nourishment"
    },
    {
      "variantId": "47303072710834",
      "name": "For Hairfall Control",
      "one_liner": "Hair Vitamin with natural hormone-blockers"
    },
    {
      "variantId": "47276523749554",
      "name": "For Metabolism",
      "one_liner": "Health Tatva for improved energy"
    },
    {
      "variantId": "46531537273010",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for scalp health"
    },
    {
      "variantId": "46530268987570",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for stress"
    },
    {
      "variantId": "46531521872050",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for hair growth"
    },
    {
      "variantId": "46530365751474",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for dandruff control"
    },
    {
      "variantId": "46528963936434",
      "name": "For Digestion",
      "one_liner": "Digest Boost for Gas and Bloating Relief"
    },
    {
      "variantId": "47302951403698",
      "name": "For Hair Nutrition",
      "one_liner": "Nourish Oil for adding shine to dull hair"
    },
    {
      "variantId": "47301148803250",
      "name": "For Hair texture",
      "one_liner": "Serum for Frizz-free, shiny hair"
    },
    {
      "variantId": "46465792704690",
      "name": "For Hair Nourishment",
      "one_liner": "Iron Santulan for deficiency triggered hair fall"
    },
    {
      "variantId": "47276517195954",
      "name": "For Stress",
      "one_liner": "Calm Ras to improve stress and sleep"
    },
    {
      "variantId": "47276531417266",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 2% that prevents hormone led hair damage"
    },
    {
      "variantId": "46465512898738",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 5% that prevents hormone led hair damage"
    },
    {
      "variantId": "44422009323698",
      "name": "For Hair Hygiene",
      "one_liner": "Defence Shampoo for pH balance (SLS Free)"
    },
    {
      "variantId": "47300731568306",
      "name": "For Hair Volume",
      "one_liner": "Serum with proven Hair Actives"
    },
    {
      "variantId": "47276511199410",
      "name": "For Digestion",
      "one_liner": "Consti Clear for improved digestion"
    },
    {
      "variantId": "47302757875890",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 01 for hair nourishment"
    },
    {
      "variantId": "47301161091250",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 02 for hair nourishment"
    },
    {
      "variantId": "46464896630962",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 05 for hair nourishment"
    },
    {
      "variantId": "47301139169458",
      "name": "For Stress & Metabolism",
      "one_liner": "Hair Ras 06 for hair nourishment"
    },
    {
      "variantId": "46464745308338",
      "name": "For Stress",
      "one_liner": "Hair Ras 09 for hair nourishment"
    }
  ];
  
  productData.forEach((each) => {
  const updated = updatedDataFromAPI.find(item => item.variantId === each.product_id);

  const displayName = updated ? updated.name : each.name;
  const displayOneLiner = updated ? updated.one_liner : each.oneLiner;

  const tagsArray = each.tag.tagKeyArray;
  let tagsHTML = '';
  if (tagsArray.length > 1) {
    tagsHTML = tagsArray.map(tag => `<p class="tag-title">${tag}</p>`).join('');
  } else {
    tagsHTML = `<p class="tag-title">${tagsArray[0]}</p>`;
  }

  const productDiv = document.createElement('div');
  productDiv.classList.add('kit-card-container');
  productDiv.dataset.productId = each.product_id;
  productDiv.innerHTML = `
      <div class="kit-card">
          <div class="box-separator-line">
              <div class="product-imge">
                  <img src="${each.image_url.singleImage}" width="80" height="80" />
              </div>
              <div class="product-description">
                  <div class="prod-heading">
                      <p class="prod-title">${displayName}</p>
                  </div>
                  <div>
                      <p class="prod-details">${displayOneLiner}</p>
                  </div>
                  <div>
                      <p class="prod-price">₹ ${Math.floor(each.price)}</p>
                  </div>
              </div>
              <div class="arrow">
                  <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.53255 7.03063L1.53255 12.0306C1.39165 12.1715 1.20056 12.2507 1.0013 12.2507C0.802043 12.2507 0.610947 12.1715 0.470051 12.0306C0.329155 11.8897 0.25 11.6986 0.25 11.4994C0.25 11.3001 0.329155 11.109 0.470051 10.9681L4.93943 6.5L0.471301 2.03063C0.401536 1.96086 0.346196 1.87804 0.308439 1.78689C0.270683 1.69574 0.25125 1.59804 0.25125 1.49938C0.25125 1.40072 0.270683 1.30302 0.308439 1.21187C0.346196 1.12072 0.401536 1.03789 0.471301 0.968128C0.541066 0.898364 0.623889 0.843023 0.715041 0.805267C0.806193 0.76751 0.903889 0.748077 1.00255 0.748077C1.10121 0.748077 1.19891 0.76751 1.29006 0.805267C1.38121 0.843023 1.46404 0.898364 1.5338 0.968128L6.5338 5.96813C6.60364 6.03789 6.65902 6.12075 6.69677 6.21196C6.73451 6.30316 6.75388 6.40093 6.75377 6.49964C6.75365 6.59835 6.73405 6.69606 6.69609 6.78718C6.65813 6.8783 6.60255 6.96103 6.53255 7.03063Z" fill="black"></path>
                  </svg>
              </div>
          </div>
          <hr class="block-line-separator d-none">
          <div class="tags tag-container d-none">
              <img src="${each.tag.icon}" alt="${each.tag.title}" class="d-none tag-icon">
              ${tagsHTML}
          </div>
      </div>
  `;
  newSection.appendChild(productDiv);

  // Add to cart logic
  if (getCookie("GuestForm_id")) {
    variantsIDs.push({
      'id': each.product_id,
      'quantity': 1,
      properties: {
        '_result_id': id
      }
    });
  } else {
    variantsIDs.push({
      'id': each.product_id,
      'quantity': 1
    });
  }
});

  containerDiv.appendChild(newSection);
  const firstSection = document.querySelectorAll('.hair_thinning_kit-container');
  if (firstSection && firstSection.parentNode) {
    firstSection.parentNode.insertBefore(containerDiv, firstSection.nextSibling);
  }
  addClickEventListernerToMonthkit();
}

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    const weeksUpdateElement = document.querySelectorAll('.weeks-update')
    weeksUpdateElement.forEach((weeksElement)=>{
      weeksElement.innerHTML = monthsExpectation.months;
    })
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}" width="100" height="100">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p>${month.goal}</p>
            </div>
        `;
       timeline.appendChild(block);
    });
    if(window.innerWidth > 767){
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "15px",
            },
          },
        ],
      });
    }
  }
}

function moneyBackPolicy(){
  const handle = 'money-back-policy';
  fetch(`/pages/${handle}.js`)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Assuming the response is JSON
  })
  .then(data => {
    console.log(data);
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
}

function rootCause (response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" width="auto" height="auto"/>
        </div>
         <p class="mt-2">${primaryRootCause[0]?.title}</p>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" width="auto" height="auto"/>
        </div>
        <p class="mt-2">${item?.title}</p>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
  }
}

// functionality for customer result male
function displayStageSection(response) {
  const stageImages = {
    "Stage-1": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage-1-img1.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img2.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img3.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stgae1-img4.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img5.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img6.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img7.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img8.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img9.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img10.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img11.webp?v=1749470793"
      ],
      customerName: "Prashant"
    },
    "Stage-2": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-1.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-2.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-3.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-4.webp?v=1749473384",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-5.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-6.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-7.webp?v=1749473383"
      ],
      customerName: "Abhishek"
    },
    "Stage-3": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-1.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-2.webp?v=1749474169",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-3.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-4.webp?v=1749474169",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-5.webp?v=1749474168"
      ],
      customerName: "Vaibhav"
    },
    "Stage-4": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-1.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-2.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-3.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-4.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-5.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-6.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-7.webp?v=1749474703",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-8.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-9.webp?v=1749474705"
      ],
      customerName: "Prem"
    },
    "Stage-5": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-1.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-2.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-image-3.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-4.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-5.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-image-6.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-7.webp?v=1749475547"
        
      ],
      customerName: "Anand"
    },
    "Heavy Hair Fall": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/heavy-hair-fall-Image.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-1.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-2.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-3.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-4.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-5.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-6.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-7.png?v=1749476010"
      ],
      customerName: "Gopal"
    },
    "Heavy Hair Fall Across The Head": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/heavy-hair-fall-Image.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-1.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-2.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-3.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-4.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-5.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-6.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-7.png?v=1749476010"
      ],
      customerName: "Gopal"
    },
    "Coin Size Patch": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-1.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-2.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-3.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-4.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-5.webp?v=1749476276"
      ],
      customerName: "Darshit"
    }
  };

  const userStage = response.User_Analysis.stage;
  const stageData = stageImages[userStage];
  console.log("User stage from response:", userStage);

  const stageContainer = document.getElementById("stageContainer");
  stageContainer.innerHTML = ""; 
  
  if (stageData && stageData.images.length > 0) {
    const p1 = document.createElement("p");
    p1.textContent = `Here is ${stageData.customerName}`;
    p1.className = "custome-stage-heading";
    stageContainer.appendChild(p1);

    const p2 = document.createElement("p");
    p2.textContent = "Who Matches Your Profile";
    p2.className = "custome-stage-subheading";
    stageContainer.appendChild(p2);

    const imageWrapper = document.createElement("div");
    imageWrapper.className = "stage-image-wrapper";

    stageData.images.forEach((imgUrl) => {
      const img = document.createElement("img");
      img.src = imgUrl;
      img.alt = userStage;
      img.className = "scrollable-stage-image"; 
      img.loading = "lazy"; 
      imageWrapper.appendChild(img);
    });

    stageContainer.appendChild(imageWrapper);
  }
}

function displayProduct(response) {  
  var resp = Object.assign(response.User_Analysis, response.Recommendations);
  f_name = resp.first_name;
  C_number = resp.phone;
  C_email = resp.email;
  user__gender = resp.gender;
  caseId = resp.case_id;
  
  setCookie('user_phone', C_number, 30);
  localStorage.setItem('caseId', caseId);

  const user_gender = user__gender === 'M' ? 'Male' : '';

  const coin_size = resp.stage === 'Coin Size Patch';

  const normal_page_is = !(resp.gender === 'M' && resp.stage === 'Stage-6');
  if (!normal_page_is) {
    document.querySelector('body.result4a').style.width = '100%';
    document.querySelector('body.result4a #MainContent').style.padding = 0;
  }

  const toggleVisibility = (selectorList, show) => {
    selectorList.forEach(el => el.classList.toggle('d-none', !show));
  };

  toggleVisibility(document.querySelectorAll('.regrowth-test-report--container'), normal_page_is);
  toggleVisibility(document.querySelectorAll('.sticky-btn'), normal_page_is);
  toggleVisibility(document.querySelectorAll('.kit-container'), normal_page_is);
  toggleVisibility(document.querySelectorAll('.hair_thinning_saw_result-container'), normal_page_is);
  toggleVisibility(document.querySelectorAll('.timeline--container'), normal_page_is);
  toggleVisibility(document.querySelectorAll('.custom-price-section'), normal_page_is);
  toggleVisibility(document.querySelectorAll('.eligibility-check--section'), normal_page_is);
  toggleVisibility(document.querySelectorAll('.aldrich-faq'), normal_page_is);

  const transplantSections = document.querySelectorAll('.transplant-stage-six');
  transplantSections.forEach(section => {
    if (!normal_page_is) {
      section.classList.remove('d-none');
    } else {
      section.remove();
    }
  });

  // Stage Title Update
  const stageTextMap = {
    "Stage-1": "Stage 1 Of ",
    "Stage-2": "Stage 2 Of ",
    "Stage-3": "Stage 3 Of ",
    "Stage-4": "Stage 4 Of ",
    "Stage-5": "Stage 5 Of ",
  };
  if (stageTextMap[resp.stage]) {
    document.querySelector('#stage').innerHTML = stageTextMap[resp.stage];
  }

  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
  document.body.style.overflow = 'unset';
}

function getProductByHandle(response) {
  let femaleResultBuyBtn = document.querySelectorAll('#add-to-cart-result-page');
  let resultTotalPrice = document.querySelectorAll('.total-price');
  let sticky_slash_price_element = document.getElementById('sticky-slash-price');
  const finalCartPrice = Math.round(response.cart_price);
  
  if (resultTotalPrice.length !== 0) {
    resultTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${finalCartPrice}`;
    });
  }
  
  if (sticky_slash_price_element) {
    sticky_slash_price_element.innerHTML = `₹ ${finalCartPrice + 500}`;
  }

  if(femaleResultBuyBtn.length != 0) {
    femaleResultBuyBtn.forEach((buyBtn) => {
      buyBtn.setAttribute('data-price', prices);
      buyBtn.addEventListener('click', ()=>{
        fireEvent("buy_now_rp1", String(response?.User_Analysis?.case_id).trim());
        window.umami.track('buy_now_click', {
          syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
          fingerprintId: window.__deviceId
        });
      });
    });
  }
}

function updateCartDrawer() {
  // Step 1: Get current cart contents
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => {
        if (item.quantity === 2) {
          updates[item.key] = 1; // Reduce quantity to 1 if it is exactly 2
        }
      });

      // Step 2: If any item needs update, call /cart/update.js in bulk
      if (Object.keys(updates).length > 0) {
        const body = {
          updates: updates
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
        .then(res => res.json())
        .then(() => {
          // Step 3: Proceed to update UI (cart bubble + drawer)
          refreshCartUI();
        })
        .catch(err => console.error('Error updating quantities:', err));
      } else {
        // No updates needed, just refresh UI
        refreshCartUI();
      }
    });
}

function bindCartDrawerEvents() {
  const closeBtn = document.querySelector('.drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('cart-drawer.drawer')?.classList.remove('active');
      document.querySelector('.cart-drawer__overlay')?.classList.remove('active');
    });
  }
}

function refreshCartUI() {
  // Update cart bubble
  fetch('/?sections=cart-icon-bubble')
  .then(res => res.json())
  .then(data => {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && data['cart-icon-bubble']) {
      cartIconBubble.innerHTML = data['cart-icon-bubble'];
    }
  });

  // Update cart drawer section
  fetch('/?sections=cart-drawer')
  .then(res => res.json())
  .then(data => {
    const cartDrawerHTML = data['cart-drawer'];
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawerHTML) {
      cartDrawer.outerHTML = cartDrawerHTML;

      // Rebind events AFTER new drawer is in DOM
      setTimeout(() => {
        bindCartDrawerEvents?.();
      }, 50);

      // Optional: Hide quantity and remove button
      document.querySelectorAll('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity').forEach(el => {
        el.style.display = 'none';
      });
    }
  })
  .catch(err => console.error('Error updating cart drawer:', err));
}

function checkout() {
  localStorage.setItem('user__gender',user_gender);
  localStorage.setItem('caseId',caseId);
  variantsIDs.forEach((e) => {
    if(e.id === 37681124081842){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 42648509186226){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 41899898011826){
      e.properties = {'Plan': 'Dandruff'};
    }else {
      e.properties = {'Plan': 'Auto'};
    }
  });
  let formData = {
    'items': variantsIDs,
    sections: 'cart-drawer',
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email,
      caseid: caseId
    }
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {  
    localStorage.setItem('User_location', "cart");
    return response.json();
  }).then(result => { 
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer);
  }).catch((error) => {
    console.error('Error:', error);
  }).finally(() => {
    updateCartDrawer();
    cartData();
    var atcButton2 = document.querySelector('#add-to-cart-result-page');
    // atcButton2.classList.remove('loader-added')
    atcButton2.disabled = false;
  });
}

function ShowContent(response) {
  const data = Object.assign(response.User_Analysis, response.Recommendations);
  const stageDescription = response.stageWiseDescription.english;
  const growthPossibility = response.growthPossibilityBar;
  const stageImage = response?.currentStage?.imgUrl;
  const userStage = data.stage;
  const genetics = data.Genetic;
  const illness = data.experienced_in_one_year;

  const grothBar = document.querySelector(".cstm-growthPossibilityBar");
  const userNameEls = document.querySelectorAll('[data-user-name]');
  const typeOfLoss3Els = document.querySelectorAll('#typeOfLoss3');
  const stageDescriptionEls = document.querySelectorAll('#stageDescription');
  const typeOfLossEls = document.querySelectorAll('#typeOfLoss');
  const mainStageEls = document.querySelectorAll('#stage');

  if (growthPossibility && grothBar) {
    grothBar.style.display = "block";
  }

  userNameEls.forEach(el => el.innerHTML = data.first_name || '');
  typeOfLoss3Els.forEach(el => el.innerHTML = data.Type_of_hair_loss || '');
  typeOfLossEls.forEach(el => el.innerHTML = data.Type_of_hair_loss || '');
  stageDescriptionEls.forEach(el => el.innerHTML = stageDescription || '');
  if(userStage === 'Heavy Hair Fall Across The Head' || userStage === 'Heavy Hair Fall' || userStage === 'Coin Size Patch') {
    document.querySelector('#stage').classList.add('d-none');
  } else {
    mainStageEls.forEach(el => el.innerHTML = data.stage || '');
    document.querySelector('#stage').classList.remove('d-none');
  }
  if (illness?.length) {
    const hasTEIllness = illness.includes('Severe Illness (Dengue, Malaria, Typhoid or Covid)');
    const isHeavyHairFall = ['Heavy Hair Fall Across The Head', 'Heavy Hair Fall'].includes(userStage);

    if (hasTEIllness && isHeavyHairFall) {
      typeOfLossEls.forEach(el => el.innerHTML = 'Telogen Effluvium');
    } else if (!hasTEIllness && genetics === 'Yes' && isHeavyHairFall) {
      typeOfLossEls.forEach(el => el.innerHTML = 'Male Pattern Hair Loss');
    } else if (!hasTEIllness && genetics === 'No' && isHeavyHairFall) {
      typeOfLossEls.forEach(el => el.innerHTML = 'Telogen Effluvium');
    } else if (userStage === 'Coin Size Patch') {
      typeOfLossEls.forEach(el => el.innerHTML = 'Coin Size Patches');
    } else if (userStage === 'Heavy Hair Fall Across The Head') {
      typeOfLossEls.forEach(el => el.innerHTML = '');
    } else {
      typeOfLossEls.forEach(el => el.innerHTML = data.Type_of_hair_loss || '');
    }
  }

  if (userStage === 'Stage-6') {
    document.querySelector('.male-treatment-plan')?.style.setProperty('display', 'none');
    document.querySelector('.aldrich-faq')?.style.setProperty('display', 'none');
  }
  
  document.querySelector(`.${userStage}`)?.classList.add('selectedStage');

  const checkMap = {
    'Stage-2': '.Stage-2-1',
    'Stage-3': '.Stage-3-1',
    'Stage-4': '.Stage-4-1',
    'Stage-5': '.Stage-5-1',
    'Stage-6': '.Stage-5', // intentional fallback
    'Coin Size Patch': '.Stage-7',
    'Heavy Hair Fall': '.Stage-8',
    'Heavy Hair Fall Across The Head': '.Stage-8'
  };

  const checkStageSelector = checkMap[userStage];
  if (checkStageSelector) {
    document.querySelector(checkStageSelector)?.classList.add('checkStage');
  }

  if (['Heavy Hair Fall', 'Heavy Hair Fall Across The Head'].includes(userStage)) {
    document.querySelector('#male-stages')?.classList.add('male-stagesTE');
    document.querySelector('.TE_stage-name')?.style.setProperty('display', 'none');
    document.querySelector('#stageDescription')?.classList.add('stageDescriptionTE');
    document.querySelector('.Stage-8-1')?.classList.add('checkStage', 'hide-text');
  }

  document.querySelectorAll('.selectedStage').forEach(stage => {
    const image = stage.querySelector('img');
    if (image && stageImage) {
      image.setAttribute('src', stageImage);
    }
  });
  
  document.querySelector('.diagnoses-result > img')?.style.setProperty('display', 'none');

  if (typeof stagesnames !== 'undefined' && stagesnames.length) {
    showOrHide(stagesnames, 'none');
  }
  
  const atcButtons = document.querySelectorAll('#add-to-cart-result-page, .sticky-btn #add-to-cart-result-page');
  atcButtons.forEach(btn => {
    btn.setAttribute('user-mobile', data.phone);
    btn.setAttribute('user-email', data.email);
  });

  // Add tracking event
  atcButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      console.log('MetaCapi');
      trackMetaEvent(response.User_Analysis, "Expand Benefits");
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var atcButton2 = document.querySelector('#add-to-cart-result-page');
  // atcButton2.classList.add('loader-added')
  atcButton2.disabled = true;
});

function cartData() {
  window.dataLayer = window.dataLayer || [];
  function gtag(){
    dataLayer.push(arguments);
  }
  fetch("/cart.js").then((cart) => {
    return cart.json();
  }).then((cart) => {
    var items = [];
    cart.items.forEach((item) => {
      items.push({
        "item_id": item.id,
        "item_name": item.title,
        "item_brand": "Traya Health",
        "item_category": "",
        "price": (parseInt(item.price) / 100),
        "quantity": item.quantity
      })
    });
    var eventData = {
      "currency": cart.currency,
      "value": (parseInt(cart.items_subtotal_price) / 100),
      "items": items
    };
    gtag("event", "view_cart", eventData);
  }).catch((error) => {
    console.error("Error: ", error);
  })
}

function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}